export default __webpack_public_path__ + "static/media/tutorial.e3c155ab.webm";